import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { newSubscribe, verifySubscribe } from "../api/subscriptionService";
import { SUBSCRIPTION_PRICE } from "../constants";

const PRICE_ID = process.env.REACT_APP_PRICE_ID || "1";
const GAMING_URL = "https://shilail.com";

export default function SubscribePage() {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [requestId, setRequestId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{9}$/.test(phone)) {
      setError("أدخل رقم هاتف صحيح مكوّن من 9 أرقام");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await newSubscribe(`249${phone}`);
      setRequestId(res.data.subscribeRequestId);
      setStep(2);
    } catch {
      setError("حدث خطأ، حاول مرة أخرى");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{4}$/.test(otp)) {
      setError("أدخل الرمز المكوّن من 4 أرقام");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await verifySubscribe(requestId, otp, PRICE_ID);
      setStep(3);
    } catch {
      setError("الرمز غلط، حاول مرة أخرى");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sub-page">
      <div className="sub-card">
        <Link to="/" className="sub-logo-link">
          <img src={logo} alt="شليل" className="sub-logo" />
        </Link>

        <div className="sub-steps">
          {[1, 2, 3].map((n, i) => (
            <Fragment key={n}>
              <span
                className={`sub-step-dot${step === n ? " s-active" : step > n ? " s-done" : ""}`}
              >
                {step > n ? "✓" : n}
              </span>
              {i < 2 && <span className="sub-step-line" />}
            </Fragment>
          ))}
        </div>

        {step === 1 && (
          <form onSubmit={handlePhoneSubmit} className="sub-form">
            <h2>اشترك في شليل للألعاب</h2>
            <div className="sub-price-badge">
              <span className="sub-price-amount">{SUBSCRIPTION_PRICE}</span>
              <span className="sub-price-label"> جنيه / اليوم</span>
            </div>
            <p className="sub-desc">أدخل رقم هاتفك لتلقي رمز التفعيل</p>
            <div className="phone-field">
              <span className="phone-prefix">+249</span>
              <input
                type="tel"
                className="phone-input"
                value={phone}
                onChange={(e) =>
                  setPhone(e.target.value.replace(/\D/g, "").slice(0, 9))
                }
                placeholder="9XXXXXXXX"
                maxLength={9}
                autoFocus
              />
            </div>
            {error && <p className="sub-error">{error}</p>}
            <button type="submit" className="btn-p sub-btn" disabled={loading}>
              {loading ? "جاري الإرسال..." : "أرسل رمز التفعيل"}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleOtpSubmit} className="sub-form">
            <h2>أدخل رمز التفعيل</h2>
            <p className="sub-desc">
              تم إرسال رمز مكوّن من 4 أرقام إلى
              <br />
              <span dir="ltr">+249{phone}</span>
            </p>
            <input
              type="tel"
              className="otp-input"
              value={otp}
              onChange={(e) =>
                setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))
              }
              placeholder="- - - -"
              maxLength={4}
              autoFocus
            />
            {error && <p className="sub-error">{error}</p>}
            <button type="submit" className="btn-p sub-btn" disabled={loading}>
              {loading ? "جاري التحقق..." : "تأكيد الاشتراك"}
            </button>
            <button
              type="button"
              className="sub-back"
              onClick={() => {
                setStep(1);
                setOtp("");
                setError("");
              }}
            >
              تغيير رقم الهاتف
            </button>
          </form>
        )}

        {step === 3 && (
          <div className="sub-success">
            <div className="sub-check">✓</div>
            <h2>تم الاشتراك بنجاح!</h2>
            <p>مرحباً بك في شليل للألعاب — أكتر من 100 لعبة بانتظارك!</p>
            <a
              href={`${GAMING_URL}?msisdn=249${phone}`}
              className="btn-p sub-btn"
            >
              🎮 ابدأ اللعب الآن
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
